module.exports = __webpack_public_path__ + "static/SiteLogoNew-3d404ee97f3893e27c0fc0a7e142587f.png";